import { Component } from 'react';

import { setToken } from './../utils/tokenStorage';

class LoginPage extends Component {
  componentDidMount() {
    const { match, history } = this.props;
    const { token } = match.params;
    setToken(`Bearer ${token}`);
    history.replace('/');
  }

  render() {
    return null;
  }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/pages/LoginPage.js